import { mergeStyleSets } from '@uifabric/merge-styles';
import { pxToRem } from '../../utils';
import theme from '../../theme.style';

export default mergeStyleSets({
  root: {
    fontWeight: 400,
  },
  errorMessage: {
    color: theme.palette.accentError,
    fontSize: pxToRem(12),
    fontWeight: 400,
    marginTop: pxToRem(5),
  },

  buttonContainer: {
    marginLeft: pxToRem(2),
    marginRight: pxToRem(2),
  },

  innerButtonClass: {
    width: `pxToRem(130) !important`,
    maxWidth: `130px !important`,
    minWidth: `130px !important`,
    flex: `0 0 !important`,
    paddingLeft: '2px !important',
    textAlign: 'left',
  },

  eraseButtonContainer: {
    position: 'relative',
    bottom: -25,
  },

  container: {
    display: 'flex',
    width: pxToRem(250),
    marginLeft: pxToRem(10),
    marginRight: pxToRem(10),
  },

  calendarHighlight: {
    selectors: {
      '.ms-DatePicker-monthOption:focus': {
        outline: `1px solid ${theme.palette.neutralLight}`,
      },
    },
  },
});
